import config from "../../config";
const baseUrl = config.baseUrl;

export const EmployeeUrls = {

 EMPLOYEE_ADD: baseUrl + "/employees",
 EMPLOYEE_EDIT: baseUrl + "/employees",
 EMPLOYEE_STATUS: baseUrl + "/employees/changedStatus",
 EMPLOYEE_LIST: baseUrl + "/employees",
 EMPLOYEE_DELETE: baseUrl + "/employees",
 EMPLOYEE_GETBYID: baseUrl + "/employees",
 EMPLOYEE_ROLLBACK: baseUrl + "/employees/rollback",
 EMPLOYEE_DROPDOWN: baseUrl + "/employees/dropdown?export=true", 
 EMPLOYEE_DROPDOWN_HANDYMAN: baseUrl + "/employees/dropdown?export=true&role=3", 
 EMPLOYEE_DELETE_HARD: baseUrl + "/employees",
 PATIENT_COUNT:baseUrl+"/patients/visitcount"
};